import { BestType } from '@diritto/common/best/constants';
import { CategoryType, ContentOrderType } from '@diritto/common/content/constants';

export enum SectionSeason {
  Season1 = 'Season1',
  Season2 = 'Season2',
}

export const SectionSeasonString = {
  [SectionSeason.Season1]: '시즌1',
  [SectionSeason.Season2]: '시즌2',
};

const SectionSeasons = [SectionSeason.Season2];

export const SectionSeasonOptions = SectionSeasons.map(it => ({
  label: SectionSeasonString[it],
  id: it,
  value: it,
}));

export enum SectionPosition {
  Home = 'Home',
  ActivityPoint = 'ActivityPoint',
  Search = 'Search',
  DirittoStudioMyContentsTop = 'DirittoStudioMyContentsTop',
  Contest = 'Contest',
}

export const SectionPositionString = {
  [SectionPosition.Home]: '홈',
  [SectionPosition.ActivityPoint]: '내 퀘스트점수',
  [SectionPosition.Search]: '검색',
  [SectionPosition.DirittoStudioMyContentsTop]: '[디리토 스튜디오] 내작품 목록 상단',
  [SectionPosition.Contest]: '픽앤츄홈',
};

const SectionPositions = [
  SectionPosition.Home,
  SectionPosition.ActivityPoint,
  SectionPosition.Search,
  SectionPosition.DirittoStudioMyContentsTop,
  SectionPosition.Contest,
];

export const SectionPositionOptions = SectionPositions.map(it => ({
  label: SectionPositionString[it],
  id: it,
  value: it,
}));

export enum SectionDesign {
  // Season 1
  DirittoRecommend = 'DirittoRecommend',

  // Season 2
  RecentlyReadContent = 'RecentlyReadContent',
  Rank = 'Rank',
  RankLite = 'RankLite',
  Content = 'Content',
  ContentLite = 'ContentLite',
  ContentCompact = 'ContentCompact',
  Reply = 'Reply',
  QuickMenu = 'QuickMenu',
  CustomQuickMenu = 'CustomQuickMenu',
  FancyShare = 'FancyShare',
  Rolling = 'Rolling',
  BarBanner = 'BarBanner',
  Banner = 'Banner',
  SmallRectBanner = 'SmallRectBanner',
  LargeRectBanner = 'LargeRectBanner',
  ContentBanner = 'ContentBanner',
  SearchKeyword = 'SearchKeyword',
  FavoriteCategory = 'FavoriteCategory',
  EventContent = 'EventContent',
  ExclusiveContent = 'ExclusiveContent',
}

export const SectionDesignString = {
  [SectionDesign.DirittoRecommend]: '디리토 추천',

  [SectionDesign.RecentlyReadContent]: '최근 읽은 작품',
  [SectionDesign.Rank]: '랭킹',
  [SectionDesign.RankLite]: '랭킹 lite',
  [SectionDesign.Content]: '작품',
  [SectionDesign.ContentLite]: '작품 lite',
  [SectionDesign.ContentCompact]: '작품 compact',
  [SectionDesign.Reply]: '댓글',
  [SectionDesign.QuickMenu]: '퀵메뉴',
  [SectionDesign.CustomQuickMenu]: '커스텀 퀵메뉴',
  [SectionDesign.FancyShare]: '이멋공',
  [SectionDesign.Rolling]: '롤링',
  [SectionDesign.BarBanner]: '바배너',
  [SectionDesign.Banner]: '바배너(old)', // @deprecated 기존 데이터 MainBanner 로 통합
  [SectionDesign.SmallRectBanner]: '사각배너|Small',
  [SectionDesign.LargeRectBanner]: '사각배너|Large',
  [SectionDesign.ContentBanner]: '작품배너',
  [SectionDesign.SearchKeyword]: '검색 키워드',
  [SectionDesign.FavoriteCategory]: '선호장르',
  [SectionDesign.EventContent]: '연재 응원 이벤트',
  [SectionDesign.ExclusiveContent]: '독점 작품',
};

const SectionDesigns = [
  SectionDesign.Content,
  SectionDesign.ContentLite,
  SectionDesign.ContentCompact,
  SectionDesign.Rank,
  SectionDesign.RankLite,
  SectionDesign.RecentlyReadContent,
  SectionDesign.Reply,
  SectionDesign.QuickMenu,
  SectionDesign.CustomQuickMenu,
  SectionDesign.FancyShare,
  SectionDesign.Rolling,
  SectionDesign.BarBanner,
  SectionDesign.Banner,
  SectionDesign.SmallRectBanner,
  SectionDesign.LargeRectBanner,
  SectionDesign.ContentBanner,
  SectionDesign.SearchKeyword,
  SectionDesign.FavoriteCategory,
  SectionDesign.EventContent,
  SectionDesign.ExclusiveContent,
];

export const SectionDesignOptions = SectionDesigns.map(it => ({
  label: SectionDesignString[it],
  id: it,
  value: it,
}));

export enum SectionData {
  None = 'None',
  Rank = 'Rank',
  RecentlyReadContent = 'RecentlyReadContent',
  SectionItem = 'SectionItem',
  ReplyRecently = 'ReplyRecently',
  ContentSorting = 'Content',
  FancyShare = 'FancyShare',
  Rolling = 'Rolling',
  BarBanner = 'BarBanner',
  Banner = 'Banner', // @deprecated
  RectBanner = 'RectBanner',
  ContentBanner = 'ContentBanner',
  SearchKeyword = 'SearchKeyword',
  CustomQuickMenu = 'CustomQuickMenu',
  FavoriteCategory = 'FavoriteCategory',
  EventContent = 'EventContent',
}

export const SectionDataString = {
  [SectionData.Rank]: '랭킹',
  [SectionData.RecentlyReadContent]: '유저의 최근 읽은 작품',
  [SectionData.ContentSorting]: '작품 정렬',
  [SectionData.ReplyRecently]: '최근 댓글',
  [SectionData.SectionItem]: '섹션 아이템',
  [SectionData.FancyShare]: '이멋공',
  [SectionData.Rolling]: '롤링',
  [SectionData.BarBanner]: '바배너',
  [SectionData.Banner]: '바배너(old)', // @deprecated
  [SectionData.RectBanner]: '사각배너',
  [SectionData.ContentBanner]: '작품배너',
  [SectionData.SearchKeyword]: '검색 키워드',
  [SectionData.CustomQuickMenu]: '커스텀 퀵메뉴',
  [SectionData.FavoriteCategory]: '선호장르',
  [SectionData.EventContent]: '연재 응원 이벤트',
  [SectionData.None]: '-',
};

export const SectionItemDataList = [SectionData.SectionItem, SectionData.EventContent];

export const SectionDataOptions = Object.values(SectionData).map(it => ({
  label: SectionDataString[it],
  id: it,
  value: it,
}));

export type BaseSectionPayload = {
  categoryTypes?: CategoryType[];
};

export type SectionDataNone = {
  type: SectionData.None;
} & BaseSectionPayload;

export type SectionDataRecentlyReadContentPayload = {
  type: SectionData.RecentlyReadContent;
} & BaseSectionPayload;

export type SectionDataSectionItemPayload = {
  type: SectionData.SectionItem;
} & BaseSectionPayload;

export type SectionDataReplyRecently = {
  type: SectionData.ReplyRecently;
} & BaseSectionPayload;

export type SectionDataFancySharePayload = {
  type: SectionData.FancyShare;
} & BaseSectionPayload;

export type SectionDataRollingPayload = {
  type: SectionData.Rolling;
  payload?: {
    tag?: string;
  };
} & BaseSectionPayload;

export type SectionDataBarBannerPayload = {
  type: SectionData.BarBanner | SectionData.Banner;
  payload: {
    iconFileId?: number;
    isExternal: boolean;
  };
} & BaseSectionPayload;

export type RectBanner = {
  id: string;
  title: string;
  description: string;
  link: string;
  fileId: number;
  startAt: Date;
  endAt: Date;
  isExternal: boolean;
};

export type SectionDataRectBannerPayload = {
  type: SectionData.RectBanner;
  payload: {
    banners: RectBanner[];
  };
} & BaseSectionPayload;

export type CustomQuickMenuItem = {
  id: string;
  title: string;
  description: string;
  link: string;
  fileId: number;
  startAt: Date;
  endAt: Date;
  isExternal: boolean;
};

export type SectionDataCustomQuickMenuPayload = {
  type: SectionData.CustomQuickMenu;
  payload: {
    items: CustomQuickMenuItem[];
  };
} & BaseSectionPayload;

export type SectionDataSearchKeywordPayload = {
  type: SectionData.SearchKeyword;
  payload: {
    keywords: string[];
  };
} & BaseSectionPayload;

export type ContentBanner = {
  title: string;
  description: string;
  contentId: number;
  link: string;
};

export type SectionDataContentBannerPayload = {
  type: SectionData.ContentBanner;
  payload: {
    banners: ContentBanner[];
  };
} & BaseSectionPayload;

export type SectionDataContentPayload = {
  type: SectionData.ContentSorting;
  payload: {
    categoryType: CategoryType | null;
    orderType: ContentOrderType;
    openedEpisodeCount?: number;
    totalItemCount?: number;
  };
} & BaseSectionPayload;

export type SectionDataRankPayload = {
  type: SectionData.Rank;
  payload: {
    categoryType: CategoryType | null;
    rankType: BestType;
  };
} & BaseSectionPayload;

export type FavoriteCategoryItem = {
  id: string;
  title: string;
  description: string;
  backgroundColor: string;
  categoryIds: number[];
};

export type SectionDataFavoriteCategoryPayload = {
  type: SectionData.FavoriteCategory;
  payload: {
    items: FavoriteCategoryItem[];
    sectionDescription?: string;
  };
} & BaseSectionPayload;

export type SectionDataEventContentPayload = {
  type: SectionData.EventContent;
  payload: {
    titleFileId: number;
    bannerFileId: number;
    description?: string;
  };
} & BaseSectionPayload;

export interface SectionDataExtraInfo {
  [SectionData.None]: SectionDataNone;
  [SectionData.Rank]: SectionDataRankPayload;
  [SectionData.ContentSorting]: SectionDataContentPayload;
  [SectionData.RecentlyReadContent]: SectionDataRecentlyReadContentPayload;
  [SectionData.ReplyRecently]: SectionDataReplyRecently;
  [SectionData.SectionItem]: SectionDataSectionItemPayload;
  [SectionData.FancyShare]: SectionDataFancySharePayload;
  [SectionData.Rolling]: SectionDataRollingPayload;
  [SectionData.BarBanner]: SectionDataBarBannerPayload;
  [SectionData.Banner]: SectionDataBarBannerPayload;
  [SectionData.RectBanner]: SectionDataRectBannerPayload;
  [SectionData.ContentBanner]: SectionDataContentBannerPayload;
  [SectionData.SearchKeyword]: SectionDataSearchKeywordPayload;
  [SectionData.CustomQuickMenu]: SectionDataCustomQuickMenuPayload;
  [SectionData.FavoriteCategory]: SectionDataFavoriteCategoryPayload;
  [SectionData.EventContent]: SectionDataEventContentPayload;
}
